/*
 * <dd-deferred-checkout>: i bottoni di pagamento rapido (PayPal, Apple Pay, Google Pay,
 * "Jetzt kaufen") di Shopify arrivano in un <template> e si attivano solo quando serve.
 *
 * Perche': sulla scheda prodotto portavano circa 385 KB di PayPal e circa 435 KB di script
 * Shopify (checkout-web, portable-wallets), con ~1,4 s di main thread, proprio mentre la
 * pagina deve ancora mostrare la foto e rispondere ai tocchi (audit SEO 2026-10-02, #18).
 *
 * Quando si attivano, nell'ordine:
 *   - alla prima interazione dell'utente (tocco, click, tasto, scroll, mouse);
 *   - oppure dopo FALLBACK_MS (20 s) dal caricamento, per chi legge senza toccare nulla. Con 6 s il timer
 *     scattava dentro la finestra di misura di Lighthouse/PageSpeed e caricava PayPal e checkout-web durante
 *     il test (15/10/2026); un acquisto richiede comunque un gesto, che li attiva prima.
 * Se il componente viene riscritto (cambio variante: il tema ricarica il blocco), le copie
 * nuove si attivano subito, perche' l'utente ha gia' interagito.
 */
(() => {
  if (window.__ddDeferredCheckout) return;
  window.__ddDeferredCheckout = true;

  const FALLBACK_MS = 20000;
  let interacted = false;

  class DdDeferredCheckout extends HTMLElement {
    connectedCallback() {
      if (interacted) this.activate();
    }

    activate() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const template = this.querySelector('template');
      if (!template) return;
      this.appendChild(template.content.cloneNode(true));
      template.remove();
    }
  }

  if (!customElements.get('dd-deferred-checkout')) {
    customElements.define('dd-deferred-checkout', DdDeferredCheckout);
  }

  const activateAll = () => {
    interacted = true;
    document.querySelectorAll('dd-deferred-checkout').forEach((el) => el.activate());
  };

  const events = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll', 'mousemove'];
  const onFirst = () => {
    events.forEach((e) => window.removeEventListener(e, onFirst, true));
    activateAll();
  };
  events.forEach((e) => window.addEventListener(e, onFirst, { capture: true, passive: true, once: true }));

  const scheduleFallback = () => setTimeout(() => { if (!interacted) onFirst(); }, FALLBACK_MS);
  if (document.readyState === 'complete') scheduleFallback();
  else window.addEventListener('load', scheduleFallback, { once: true });
})();
